import * as React from "react"
import * as styles from "./styles.css"
import { intervalToDuration, Duration } from "date-fns"

type StatusPillProps = {
  createdAt: string
  endedAt: string
}

export function TotalTime({ createdAt, endedAt }: StatusPillProps) {
  let timeParts

  if (endedAt) {
    timeParts = intervalToDuration({
      start: new Date(createdAt).getTime(),
      end: new Date(endedAt).getTime(),
    })
  } else {
    timeParts = intervalToDuration({
      start: new Date(createdAt).getTime(),
      end: Date.now(),
    })
  }

  const removeZero = (item: Duration) =>
    Object.keys(item)
      .filter(key => item[key as keyof Duration] !== 0)
      .reduce(
        (newObj, key) =>
          Object.assign(newObj, { [key[0]]: item[key as keyof Duration] }),
        {}
      )

  const result = removeZero(timeParts)

  const timeStr = Object.keys(result)
    .map(key => `${result[key]}${key}`)
    .join(" ")

  return (
    <div className={styles.title}>
      Total time
      <div className={styles.content}>{timeStr ? timeStr : `0s`}</div>
    </div>
  )
}
